import React from 'react'
import styled from 'styled-components'
import {usePopupToggle} from '@startlibs/core'
import {getColor} from '@startlibs/utils'
import {Icon,ContextMenu,Li} from '@startlibs/components'
import {useFormValue} from '@startlibs/form'

const ExpirationSelectButton = styled.div`
  background-color: rgba(0,0,0,0.06);
  border-radius: 6px;
  padding: 0.5rem 2.75rem 0.5rem 1rem;
  min-height: 36px;
  margin-bottom: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -0.5rem;
  position: relative;
  :hover {
    background-color: rgba(0,0,0,0.08);
  }
  :active {
    background-color: rgba(0,0,0,0.1);
  }
  .help-text {
    font-weight: 400;
    color: ${getColor('gray120')};
    font-size: 12px;
  }
  ${Icon} {
    font-size: 12px;
    color: rgba(0,0,0,0.5);
    right: 1rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`


const EXPIRATION_TIMES = [0, 48, 168]

const EXPIRATION_LABELS = {
  [0]: 'Never (access link will not expire)',
  [48]: '48 hours (recipients will not have access after 48 hours)',
  [168]: '1 week (recipients will not have access after 1 week)'
}


export const ExpirationSelect = ({path = 'expirationTime', options = EXPIRATION_TIMES, getLabel = (time) => EXPIRATION_LABELS[time]}) => {
  const menu = usePopupToggle()
  const [expiration, setExpiration] = useFormValue(path)
  return <ExpirationSelectButton onClick={menu.toggle}>
    <div><b>Expiration time:</b> <span className="help-text">{getLabel(expiration)}</span></div>
    <Icon icon="arrow-down"/>
    {
      menu.isOpen &&
      <ContextMenu fill>
        {options.map(time =>
          <Li icon={time === expiration && 'check'} label={getLabel(time)} key={time + ''}
              onClick={() => setExpiration(time)}/>
        )}
      </ContextMenu>
    }
  </ExpirationSelectButton>
}